import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import type { FileType } from '#types/file-type.type';

import { Uri } from '#constants/uri';

/**
 * Retrieves the list of available file types from the lookup API.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @returns A promise that resolves to an `OperationResultWithData` containing an array of `FileType` objects.
 * @throws Throws an error if the HTTP request fails.
 */
export const getFileTypes = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<FileType[]>>(Uri.lookup.fileTypes).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
